export const INSTRUMENTS = {
	CBCL_ESCOLAR: "efd76a13-4998-4a07-b2a5-38fec4c54b97",
	CBCL_PREESCOLAR: "c91fc893-a9e0-46fb-819d-d307796fe56d",
	D2: "06286bc3-978f-413e-aaf4-0953be5a11e0",
	ASRS: "dca9e6c3-052d-486e-86de-5690ef1579fb",
	BSI: "7665bcec-5e5f-453e-a0d5-3958579d42a3",
	INTAKE_A: "b0a84472-d677-4fd5-ad4c-082d48545a06",
	INTAKE_C: "481e8b9a-f051-495b-967a-262f90b8e831"
};


export const GROUPED_NORMS_INSTRUMENT_IDS: Array<string> = [
	INSTRUMENTS.CBCL_ESCOLAR,
	INSTRUMENTS.CBCL_PREESCOLAR,
	INSTRUMENTS.D2,
	INSTRUMENTS.ASRS
];

export const EXTRA_MEAN_COLUMN_INSTRUMENT_IDS: Array<string> = [INSTRUMENTS.BSI];

const CBCL_PREESCOLAR_GROUPING_DIMENSIONS = ["I_5", "E_5", "TOTAL_5"];
const CBCL_ESCOLAR_GROUPING_DIMENSIONS = ["I", "E", "TOTAL"];
const BSI_GROUPING_DIMENSIONS = ["BSI-IGS", "BSI-TSP", "BSI-ISP"];
const ASRS_GROUPING_DIMENSIONS = ["part_a"];

export const EMPHASIZED_DIMENSION_CODES = [
	...CBCL_ESCOLAR_GROUPING_DIMENSIONS,
	...CBCL_PREESCOLAR_GROUPING_DIMENSIONS,
	...BSI_GROUPING_DIMENSIONS,
	...ASRS_GROUPING_DIMENSIONS
];
